import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import Player from '../../../../core/components/molecules/Player';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../core/constants/modal-videos';

interface RegularCoursesInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function RegularCoursesInfoModal({
  isOpen,
  onClose,
}: RegularCoursesInfoModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='md'
      title='Saiba mais sobre os cursos regulares'
    >
      <Player
        playerType='vimeo'
        className='h-[265px]'
        token={MODAL_VIDEOS_VIMEO_ALLOWED.CURSO_REGULAR.token}
        initialTime={0}
      />
    </Modal>
  );
}

export { RegularCoursesInfoModal };
